import type { MediaItem } from "@/types/media";

export const movies: MediaItem[] = [
  {
    id: "movie-01",
    title: "星河彼岸",
    type: "movie",
    genre: "科幻",
    region: "美国",
    year: 2026,
    rating: 8.7,
    director: "陈墨白",
    actors: ["林知远", "苏晚晴", "Kevin Ross"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20artwork%20of%20a%20lone%20astronaut%20standing%20before%20a%20giant%20glowing%20nebula%20portal%2C%20deep%20indigo%20violet%20cosmic%20background%20with%20warm%20orange%20rim%20lighting%2C%20minimalist%20modern%20key%20art%2C%20dramatic%20moody%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-01&orientation=portrait",
    description:
      "一支深空勘探队穿越虫洞抵达未知星系，在寻找失联舰队的过程中，船员们逐渐发现宇宙深处藏着改写人类命运的惊人秘密。",
    views: 1860000,
    updatedAt: "2026-10-11",
    tags: ["科幻", "太空", "史诗"],
    duration: "142分钟",
  },
  {
    id: "movie-02",
    title: "暗夜追凶",
    type: "movie",
    genre: "悬疑",
    region: "中国大陆",
    year: 2025,
    rating: 8.2,
    director: "周立坤",
    actors: ["唐正阳", "许晴岚", "罗天宇"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20movie%20poster%20of%20a%20detective%20silhouette%20under%20rain%20in%20a%20dark%20city%20alley%2C%20deep%20purple%20blue%20night%20backdrop%20with%20warm%20orange%20streetlight%20glow%2C%20minimalist%20modern%20key%20art%2C%20tense%20moody%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-02&orientation=portrait",
    description:
      "城市连环命案再现，退休刑警与年轻法医被迫联手追查。随着线索深入，一桩尘封十年的旧案浮出水面，真相远比想象更加残酷。",
    views: 1520000,
    updatedAt: "2026-10-09",
    tags: ["悬疑", "犯罪", "推理"],
    duration: "128分钟",
  },
  {
    id: "movie-03",
    title: "风起长安",
    type: "movie",
    genre: "古装",
    region: "中国大陆",
    year: 2024,
    rating: 8.9,
    director: "顾岚之",
    actors: ["沈书言", "白芸溪", "崔昊然"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20historical%20epic%20movie%20poster%20of%20a%20general%20in%20ancient%20chinese%20armor%20before%20a%20vast%20imperial%20palace%2C%20deep%20indigo%20violet%20sky%20with%20warm%20orange%20torch%20light%2C%20minimalist%20elegant%20key%20art%2C%20epic%20moody%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-03&orientation=portrait",
    description:
      "大唐末年，一介寒门书生凭满腹谋略闯入朝堂。在权臣倾轧与边关烽火之间，他以一己之力书写了一段风起云涌的传奇。",
    views: 2140000,
    updatedAt: "2026-10-07",
    tags: ["古装", "历史", "权谋"],
    duration: "158分钟",
  },
  {
    id: "movie-04",
    title: "深海回响",
    type: "movie",
    genre: "灾难",
    region: "中国大陆",
    year: 2025,
    rating: 7.8,
    director: "韩雪松",
    actors: ["邓一鸣", "柳思彤", "赵敬尧"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20disaster%20movie%20poster%20of%20a%20submarine%20sinking%20deeper%20into%20a%20dark%20turbulent%20ocean%2C%20deep%20indigo%20underwater%20backdrop%20with%20warm%20orange%20emergency%20light%2C%20minimalist%20modern%20key%20art%2C%20harrowing%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-04&orientation=portrait",
    description:
      "深海科考潜艇突发故障失去联系，舱内氧气仅剩七十二小时。面对未知的海底威胁与内部争执，工程师必须带领船员寻找唯一的生路。",
    views: 980000,
    updatedAt: "2026-10-05",
    tags: ["灾难", "深海", "求生"],
    duration: "118分钟",
  },
  {
    id: "movie-05",
    title: "时光信笺",
    type: "movie",
    genre: "爱情",
    region: "韩国",
    year: 2024,
    rating: 8.1,
    director: "金泰旭",
    actors: ["孙语桐", "李承宇", "朴素拉"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20romantic%20drama%20movie%20poster%20of%20a%20young%20couple%20writing%20letters%20beside%20a%20rainy%20window%2C%20deep%20indigo%20twilight%20backdrop%20with%20warm%20orange%20lamp%20glow%2C%20minimalist%20soft%20key%20art%2C%20tender%20nostalgic%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-05&orientation=portrait",
    description:
      "一封寄错地址的信，让两个素未谋面的人开始了跨越时空的对话。在字里行间，他们渐渐爱上彼此，命运却早已写下不同的答案。",
    views: 1130000,
    updatedAt: "2026-10-03",
    tags: ["爱情", "治愈", "怀旧"],
    duration: "124分钟",
  },
  {
    id: "movie-06",
    title: "钢铁黎明",
    type: "movie",
    genre: "动作",
    region: "美国",
    year: 2026,
    rating: 7.9,
    director: "Marcus Lee",
    actors: ["Ryan Cole", "林知远", "Amy Foster"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20action%20movie%20poster%20of%20a%20battle-worn%20mechanic%20soldier%20facing%20a%20burning%20ruined%20city%2C%20deep%20purple%20blue%20smoke%20backdrop%20with%20warm%20orange%20fire%20glow%2C%20minimalist%20modern%20key%20art%2C%20explosive%20intense%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-06&orientation=portrait",
    description:
      "在机械军团席卷大陆的末日，一名退役老兵为了守护家园重新披甲上阵。他要在黎明到来之前，摧毁敌人最致命的钢铁堡垒。",
    views: 1670000,
    updatedAt: "2026-10-10",
    tags: ["动作", "机甲", "末日"],
    duration: "136分钟",
  },
  {
    id: "movie-07",
    title: "雾都疑云",
    type: "movie",
    genre: "犯罪",
    region: "英国",
    year: 2023,
    rating: 8.4,
    director: "Oliver Hart",
    actors: ["Eleanor Style", "James Doyle", "许晴岚"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20noir%20crime%20movie%20poster%20of%20a%20silhouette%20in%20a%20foggy%20victorian%20london%20street%2C%20deep%20indigo%20misty%20backdrop%20with%20warm%20orange%20gaslight%20glow%2C%20minimalist%20elegant%20key%20art%2C%20mysterious%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-07&orientation=portrait",
    description:
      "浓雾笼罩的伦敦接连发生离奇失踪案，一位落魄记者意外卷入调查。层层迷雾之下，隐藏着上流社会不愿被揭开的黑暗交易。",
    views: 740000,
    updatedAt: "2026-09-28",
    tags: ["犯罪", "推理", "黑色电影"],
    duration: "131分钟",
  },
  {
    id: "movie-08",
    title: "山海秘境",
    type: "movie",
    genre: "奇幻",
    region: "中国大陆",
    year: 2025,
    rating: 8.0,
    director: "顾岚之",
    actors: ["白芸溪", "崔昊然", "姜雨薇"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20adventure%20movie%20poster%20of%20a%20young%20hero%20crossing%20a%20floating%20mythic%20mountain%20waterfall%2C%20deep%20violet%20mystic%20backdrop%20with%20warm%20orange%20sunrise%20glow%2C%20minimalist%20ornate%20key%20art%2C%20dreamlike%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-08&orientation=portrait",
    description:
      "古籍中记载的山海异境重现人间，一位少女为寻找失踪的兄长踏入秘境。凶兽、灵药与古老封印背后，是一场关乎两界的宏大阴谋。",
    views: 1290000,
    updatedAt: "2026-10-06",
    tags: ["奇幻", "冒险", "东方美学"],
    duration: "147分钟",
  },
  {
    id: "movie-09",
    title: "末路狂飙",
    type: "movie",
    genre: "动作",
    region: "美国",
    year: 2024,
    rating: 7.6,
    director: "Derek Nolan",
    actors: ["Chris Vega", "Nina Brooks", "邓一鸣"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20racing%20action%20movie%20poster%20of%20a%20muscle%20car%20speeding%20through%20a%20desert%20highway%20at%20night%2C%20deep%20purple%20blue%20sky%20with%20warm%20orange%20headlight%20trails%2C%20minimalist%20dynamic%20key%20art%2C%20high-octane%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-09&orientation=portrait",
    description:
      "为了救出被绑架的弟弟，前赛车手被迫参与一场横跨大陆的亡命飙车赛。每一段路程都是陷阱，每一个对手都想要他的命。",
    views: 880000,
    updatedAt: "2026-09-30",
    tags: ["动作", "赛车", "犯罪"],
    duration: "109分钟",
  },
  {
    id: "movie-10",
    title: "城南旧梦",
    type: "movie",
    genre: "剧情",
    region: "中国大陆",
    year: 2023,
    rating: 8.6,
    director: "周立坤",
    actors: ["唐正阳", "林知远", "苏晚晴"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20family%20drama%20movie%20poster%20of%20an%20old%20chinese%20town%20alley%20with%20a%20child%20looking%20back%2C%20deep%20indigo%20dusk%20backdrop%20with%20warm%20orange%20lantern%20glow%2C%20minimalist%20nostalgic%20key%20art%2C%20warm%20melancholic%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-10&orientation=portrait",
    description:
      "一座即将拆迁的老城，一群守着回忆不肯离去的居民。透过少年的眼睛，一段关于离别、成长与守望的城市往事缓缓展开。",
    views: 690000,
    updatedAt: "2026-09-25",
    tags: ["剧情", "家庭", "年代"],
    duration: "135分钟",
  },
  {
    id: "movie-11",
    title: "机械之心",
    type: "movie",
    genre: "科幻",
    region: "日本",
    year: 2025,
    rating: 8.3,
    director: "松本健一",
    actors: ["藤原蓝", "姜雨薇", "罗天宇"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20anime%20style%20movie%20poster%20of%20a%20humanoid%20robot%20girl%20in%20a%20neon%20city%2C%20deep%20indigo%20violet%20cyberpunk%20backdrop%20with%20warm%20orange%20neon%20glow%2C%20minimalist%20modern%20key%20art%2C%20futuristic%20emotional%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-11&orientation=portrait",
    description:
      "当仿生人拥有了真正的记忆，她开始质疑自己存在的意义。为了解决一场都市危机，她必须找到制造者的女儿，也找回自己的“心”。",
    views: 1440000,
    updatedAt: "2026-10-08",
    tags: ["科幻", "人工智能", "温情"],
    duration: "116分钟",
  },
  {
    id: "movie-12",
    title: "荒漠孤影",
    type: "movie",
    genre: "西部",
    region: "美国",
    year: 2022,
    rating: 8.0,
    director: "Hank Miller",
    actors: ["Clay Robbins", "Daisy Hale", "崔昊然"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20western%20movie%20poster%20of%20a%20lone%20cowboy%20riding%20across%20a%20vast%20canyon%20at%20sunset%2C%20deep%20purple%20desert%20horizon%20with%20warm%20orange%20dust%20glow%2C%20minimalist%20gritty%20key%20art%2C%20lonesome%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-12&orientation=portrait",
    description:
      "一名身负旧账的赏金猎人独自追踪仇人，穿越无尽荒漠。水源、子弹和信任都在快速耗尽，终点等待他的却是一个更大的意外。",
    views: 520000,
    updatedAt: "2026-09-20",
    tags: ["西部", "复仇", "公路"],
    duration: "126分钟",
  },
  {
    id: "movie-13",
    title: "春夜喜雨",
    type: "movie",
    genre: "文艺",
    region: "中国大陆",
    year: 2024,
    rating: 7.7,
    director: "韩雪松",
    actors: ["许晴岚", "沈书言", "柳思彤"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poetic%20drama%20movie%20poster%20of%20a%20woman%20standing%20by%20a%20quiet%20riverside%20village%20in%20spring%20rain%2C%20deep%20indigo%20misty%20backdrop%20with%20warm%20orange%20window%20light%2C%20minimalist%20serene%20key%20art%2C%20gentle%20contemplative%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-13&orientation=portrait",
    description:
      "离开故乡多年的女作家回到小镇整理旧屋，在连绵春雨里重新遇见儿时的伙伴与未竟的心事。这一次，她决定不再逃避。",
    views: 430000,
    updatedAt: "2026-09-18",
    tags: ["文艺", "剧情", "女性"],
    duration: "112分钟",
  },
  {
    id: "movie-14",
    title: "极地营救",
    type: "movie",
    genre: "冒险",
    region: "中国大陆",
    year: 2026,
    rating: 7.5,
    director: "赵敬尧",
    actors: ["邓一鸣", "姜雨薇", "崔昊然"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20survival%20adventure%20movie%20poster%20of%20climbers%20on%20a%20snow%20mountain%20in%20a%20blizzard%2C%20deep%20indigo%20icy%20backdrop%20with%20warm%20orange%20rescue%20flare%20glow%2C%20minimalist%20modern%20key%20art%2C%20freezing%20tense%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-14&orientation=portrait",
    description:
      "一支登山队在极地遭遇罕见暴风雪与雪崩，被困冰缝之中。救援直升机燃料有限，队长必须在生死边缘做出残酷的抉择。",
    views: 810000,
    updatedAt: "2026-10-04",
    tags: ["冒险", "灾难", "求生"],
    duration: "121分钟",
  },
  {
    id: "movie-15",
    title: "无声证词",
    type: "movie",
    genre: "悬疑",
    region: "韩国",
    year: 2025,
    rating: 8.5,
    director: "金泰旭",
    actors: ["李承宇", "孙语桐", "罗天宇"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20courtroom%20mystery%20movie%20poster%20of%20a%20deaf%20witness%20raising%20a%20hand%20in%20a%20dim%20courtroom%2C%20deep%20purple%20blue%20backdrop%20with%20warm%20orange%20spotlight%20glow%2C%20minimalist%20dramatic%20key%20art%2C%20tense%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-15&orientation=portrait",
    description:
      "一起看似简单的命案庭审，唯一目击者却是听障少年。一件件被忽略的细节串联起来，指向了所有人都没料到的真凶。",
    views: 1360000,
    updatedAt: "2026-10-02",
    tags: ["悬疑", "法庭", "推理"],
    duration: "129分钟",
  },
  {
    id: "movie-16",
    title: "幻境之门",
    type: "movie",
    genre: "奇幻",
    region: "美国",
    year: 2023,
    rating: 7.9,
    director: "Marcus Lee",
    actors: ["Amy Foster", "林知远", "Nina Brooks"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20portal%20fantasy%20movie%20poster%20of%20a%20glowing%20doorway%20between%20two%20worlds%2C%20deep%20indigo%20violet%20magic%20backdrop%20with%20warm%20orange%20energy%20glow%2C%20minimalist%20surreal%20key%20art%2C%20wondrous%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-16&orientation=portrait",
    description:
      "一扇出现在废弃车站的神秘之门，通往一个时间错乱的平行世界。少女为找回失踪的母亲踏入其中，却发现一切都与她想象不同。",
    views: 970000,
    updatedAt: "2026-09-27",
    tags: ["奇幻", "平行世界", "亲情"],
    duration: "113分钟",
  },
  {
    id: "movie-17",
    title: "逆流而上",
    type: "movie",
    genre: "励志",
    region: "中国大陆",
    year: 2024,
    rating: 8.2,
    director: "周立坤",
    actors: ["唐正阳", "白芸溪", "赵敬尧"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20inspirational%20sports%20movie%20poster%20of%20a%20swimmer%20emerging%20from%20splashing%20water%20in%20a%20stadium%2C%20deep%20indigo%20violet%20backdrop%20with%20warm%20orange%20spotlight%20glow%2C%20minimalist%20dynamic%20key%20art%2C%20triumphant%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-17&orientation=portrait",
    description:
      "一个被省队淘汰的小镇少年，凭着不服输的执念重返赛场。在冠军教练的打磨下，他要向所有人证明，命运可以从水里改写。",
    views: 1050000,
    updatedAt: "2026-09-26",
    tags: ["励志", "运动", "青春"],
    duration: "120分钟",
  },
  {
    id: "movie-18",
    title: "暗涌",
    type: "movie",
    genre: "惊悚",
    region: "西班牙",
    year: 2025,
    rating: 7.8,
    director: "Pablo Serra",
    actors: ["Lucia Mendez", "Diego Roca", "许晴岚"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20psychological%20thriller%20movie%20poster%20of%20a%20woman%20staring%20into%20a%20cracked%20mirror%20in%20a%20dim%20room%2C%20deep%20purple%20blue%20backdrop%20with%20warm%20orange%20candle%20glow%2C%20minimalist%20eerie%20key%20art%2C%20unsettling%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-18&orientation=portrait",
    description:
      "搬进海边别墅的年轻夫妇发现，这栋房子似乎记得前任住户的一切。随着幻象愈发真实，一段被掩埋的家族秘密开始反噬。",
    views: 620000,
    updatedAt: "2026-09-24",
    tags: ["惊悚", "悬疑", "心理"],
    duration: "105分钟",
  },
  {
    id: "movie-19",
    title: "长夜将尽",
    type: "movie",
    genre: "剧情",
    region: "中国大陆",
    year: 2026,
    rating: 8.8,
    director: "顾岚之",
    actors: ["沈书言", "苏晚晴", "崔昊然"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20historical%20drama%20movie%20poster%20of%20a%20man%20carrying%20a%20lantern%20through%20a%20war-torn%20town%20at%20dawn%2C%20deep%20indigo%20twilight%20backdrop%20with%20warm%20orange%20lantern%20glow%2C%20minimalist%20solemn%20key%20art%2C%20hopeful%20melancholic%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-19&orientation=portrait",
    description:
      "战乱年代，一位乡村教师在废墟中坚持开办学堂。他用一盏灯、一本书，为流离失所的孩子们守住了长夜结束前最后的希望。",
    views: 1980000,
    updatedAt: "2026-10-12",
    tags: ["剧情", "历史", "人文"],
    duration: "149分钟",
  },
  {
    id: "movie-20",
    title: "猎户座信号",
    type: "movie",
    genre: "科幻",
    region: "美国",
    year: 2025,
    rating: 8.4,
    director: "Derek Nolan",
    actors: ["Ryan Cole", "林知远", "Amy Foster"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20thriller%20movie%20poster%20of%20a%20radio%20telescope%20array%20under%20a%20star-filled%20sky%2C%20deep%20indigo%20violet%20cosmic%20backdrop%20with%20warm%20orange%20instrument%20glow%2C%20minimalist%20modern%20key%20art%2C%20mysterious%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-20&orientation=portrait",
    description:
      "天文台接收到一段来自猎户座的重复信号，破译后发现那竟是一份精确的倒计时。人类必须在有限时间里，解开信号背后的真相。",
    views: 1590000,
    updatedAt: "2026-10-01",
    tags: ["科幻", "悬疑", "天文"],
    duration: "133分钟",
  },
  {
    id: "movie-21",
    title: "花街往事",
    type: "movie",
    genre: "剧情",
    region: "香港",
    year: 2023,
    rating: 8.1,
    director: "何蔚然",
    actors: ["罗天宇", "柳思彤", "沈书言"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20hong%20kong%20drama%20movie%20poster%20of%20a%20narrow%20neon-lit%20street%20with%20paper%20lanterns%2C%20deep%20indigo%20violet%20night%20backdrop%20with%20warm%20orange%20neon%20glow%2C%20minimalist%20retro%20key%20art%2C%20nostalgic%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-21&orientation=portrait",
    description:
      "旧区拆迁在即，一家开了三十年的糖水铺迎来最后一个夏天。老板娘与几位老街坊的日常，拼凑出一座城市的烟火与温度。",
    views: 560000,
    updatedAt: "2026-09-22",
    tags: ["剧情", "港风", "人情"],
    duration: "114分钟",
  },
  {
    id: "movie-22",
    title: "雷霆突击",
    type: "movie",
    genre: "战争",
    region: "美国",
    year: 2024,
    rating: 7.7,
    director: "Hank Miller",
    actors: ["Chris Vega", "Clay Robbins", "邓一鸣"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20war%20movie%20poster%20of%20soldiers%20advancing%20through%20a%20ruined%20european%20town%20at%20dusk%2C%20deep%20purple%20blue%20smoke%20backdrop%20with%20warm%20orange%20explosion%20glow%2C%20minimalist%20gritty%20key%20art%2C%20intense%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-22&orientation=portrait",
    description:
      "二战末期，一支特种小队奉命深入敌后摧毁关键补给线。在弹尽粮绝的绝境中，他们用鲜血与默契完成了一场几乎不可能的任务。",
    views: 890000,
    updatedAt: "2026-09-29",
    tags: ["战争", "动作", "群像"],
    duration: "138分钟",
  },
  {
    id: "movie-23",
    title: "归途列车",
    type: "movie",
    genre: "家庭",
    region: "中国大陆",
    year: 2025,
    rating: 8.6,
    director: "韩雪松",
    actors: ["赵敬尧", "白芸溪", "柳思彤"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20family%20road%20movie%20poster%20of%20an%20old%20train%20crossing%20a%20rural%20chinese%20landscape%20at%20dusk%2C%20deep%20indigo%20evening%20backdrop%20with%20warm%20orange%20train%20window%20glow%2C%20minimalist%20warm%20key%20art%2C%20tender%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-23&orientation=portrait",
    description:
      "在南方打工的父亲决定带留守多年的儿子回一趟老家。一趟缓慢的绿皮火车，让隔阂多年的父子终于有机会把心里话说完。",
    views: 1180000,
    updatedAt: "2026-10-09",
    tags: ["家庭", "公路", "治愈"],
    duration: "117分钟",
  },
  {
    id: "movie-24",
    title: "量子囚笼",
    type: "movie",
    genre: "科幻",
    region: "英国",
    year: 2026,
    rating: 8.2,
    director: "Oliver Hart",
    actors: ["Eleanor Style", "James Doyle", "罗天宇"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20thriller%20movie%20poster%20of%20a%20person%20trapped%20inside%20a%20glowing%20geometric%20energy%20cage%2C%20deep%20indigo%20violet%20digital%20backdrop%20with%20warm%20orange%20particle%20glow%2C%20minimalist%20futuristic%20key%20art%2C%20claustrophobic%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=movie-24&orientation=portrait",
    description:
      "物理学家在一次实验事故后醒来，发现自己被困在不断重置的十分钟里。想要逃脱，他必须先弄明白：谁在操控这场循环实验。",
    views: 1410000,
    updatedAt: "2026-10-11",
    tags: ["科幻", "悬疑", "时间循环"],
    duration: "127分钟",
  },
];